const storagePrefix = "auth_";

const storage = {
  getToken: () => {
    try {
      const token = localStorage.getItem(`${storagePrefix}token`);
      if (typeof token === "string" && token !== null) {
        return JSON.parse(token);
      }
      return null;
    } catch (error) {
      console.error("Error getting token from localStorage:", error);
      return null;
    }
  },
  setToken: (token) => {
    try {
      if (token === null || token === undefined) {
        console.warn("Attempting to set null or undefined token");
        return false;
      }
      window.localStorage.setItem(
        `${storagePrefix}token`,
        JSON.stringify(token)
      );
      return true;
    } catch (error) {
      console.error("Error setting token in localStorage:", error);
      return false;
    }
  },
  clearToken: () => {
    try {
      window.localStorage.removeItem(`${storagePrefix}token`);
      return true;
    } catch (error) {
      console.error("Error clearing token from localStorage:", error);
      return false;
    }
  },
};

export default storage;
